export { default as initCells } from './initCells'
export { moveCells, directions } from './moveCells'
export { removeAndIncreaseCells } from './removeAndIncreaseCells'
export { populateField } from './populateField'



// WEBPACK FOOTER //
// ./src/logic/index.js